import React from 'react';
import Select from 'react-select';

export const MultiSelectField = (props) => {
    const {
        input,
        options,
        disabled,
        meta: {touched, error}
    } = props;

    const getSelectOptions = (options) => {
        const optionsList = [];

        options.map(option => option.display_name ?
            optionsList.push({
                value: option.id,
                label: option.display_name,
            }) : optionsList.push({
                value: option.id,
                label: option.name,
            })
        );

        return optionsList;
    };

    return (
        <div>
            <Select
                {...input}
                closeOnSelect={false}
                multi={true}
                value={input.value}
                onBlur={() => input.onBlur(input.value)}
                options={getSelectOptions(options)}
                error={touched && error ? true : false}
                disabled={disabled}
            />
            <br />
            {touched && error && <span className="errMsg"> {error} </span>}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_multi_select_user.js